<template>
<div class="chapter">
<div class="inner_page">
<p class="img"><a id="page5"></a><img alt="image" src="images/p5.jpg"/></p>
<p class="pagebreak"></p>
<div class="booksection"><p class="img"><img alt="image" src="images/log.jpg"/></p>
<p class="chapter-opener-title-toc"><span class="bold">CONTENTS</span></p>
<p class="chapter_opener_toc"><span class="bold"><a href="#/intro">INTRODUCTION</a></span></p>
<p class="chapter_opener_toc"><span class="bold"><a href="#/cap01">EQUIPMENT</a></span></p>
<p class="chapter_opener_toc"><span class="bold"><a href="#/cap02">TECHNIQUES</a></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap03" title="Link target outside of Sample">BURGERS</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap04" title="Link target outside of Sample">BEEF</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap05" title="Link target outside of Sample">PORK</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap06" title="Link target outside of Sample">CHICKEN, TURKEY &amp; OTHER BIRDS</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap07" title="Link target outside of Sample">FISH &amp; SHELLFISH</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap08" title="Link target outside of Sample">VEGETABLES</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap09" title="Link target outside of Sample">PIZZA</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap10" title="Link target outside of Sample">DESSERT</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/cap11" title="Link target outside of Sample">BRINES, RUBS &amp; SAUCES</span></span></p>
<p class="chapter_opener_toc"><span class="bold"><span href="#/index" title="Link target outside of Sample">INDEX</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1e7f79f1